import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    WebView,
    ActivityIndicator, Linking,
    Text, PermissionsAndroid,

    AppState
} from "react-native";
import {connect} from "react-redux";
import HMActionBarSatia from "../../../customviews/HMActionBarSatia";


class FirstHotSpotScreen extends Component {


    render() {
        let {NameHotspotConnect, NameHotspot, successLogin} = this.state;
        // let _params = this.props.route.params;
        //let _item = JSON.parse(_params.item);
        //let item = this.props.route && this.props.route.params ? _item : {}

        console.log(" this.state.successLogin || this.props.ConnectionInternetHotspot", this.state.successLogin, this.props.DataSplashSatiaScreen.successLogin);

        return (


            <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                  enabled={Platform.OS === "ios"}>

                <HMActionBarSatia
                    // menu
                    props={this.props} statusBarTransparent
                    // text={i18n.t('ListNews.title')}
                    //text={i18n.t('ListNews.title')}
                    text={"هات اسپات"}

                    back
                    //  text={i18n.t('constant.Information')}

                    headerVisibility more_menu
                    onBackPress={() => this.props.navigation.pop()}

                />


            </KeyboardAvoidingView>

        );
    }

}

const mapStateToProps = state => {
    return {
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,
        wifiIsEnabled: state.reducerSplashSatiaScreen.wifiIsEnabled,
        wifiConnectionStatus: state.reducerSplashSatiaScreen.wifiConnectionStatus,
        ConnectionInternetHotspot: state.reducerSplashSatiaScreen.ConnectionInternetHotspot,
        ConnectionType: state.reducerSplashSatiaScreen.ConnectionType,

    };
};
const styles = StyleSheet.create({
    WebViewStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        marginTop: 40,
    },
    ActivityIndicatorStyle: {
        flex: 1,
        justifyContent: 'center',
    },
});
const mapDispatchToProps = dispatch => {
    return {
        //    callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        // callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FirstHotSpotScreen);
